export default __webpack_public_path__ + "static/media/hh-web-logo-pink.8f202e56.png";